import authRo from "./authRo";
import commonRo from "./commonRo";
import footerRo from "./footerRo";
import galleryRo from "./galleryRo";
import menuRo from "./menuRo";
import navigationRo from "./navigationRo";
import orderRo from "./orderRo";
import paymentRo from "./paymentRo";
import statisticsRo from "./statisticsRo";

const mainRo = {
    common: commonRo,
    navigation: navigationRo,
    menu: menuRo,
    statistics: statisticsRo,
    order: orderRo,
    payment: paymentRo,
    auth: authRo,
    gallery: galleryRo,
    footer: footerRo,
};

export default mainRo;
